export default "__VITE_ASSET__8n1tXeOf__"